const Groups = () => {
    return (
        <>
            <p className='Help__Title'>Crear grupo</p>

            <img src='/img/support/help/instructor/groups/1.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Crear grupo</span>?</p>
            <p>Permite al instructor organizar Ztudiantes según la matrícula o criterios institucionales. Al presionar el botón, Ztudia solicita el nombre del grupo, que servirá como etiqueta para identificarlo fácilmente. Una vez creado, Ztudia genera un código único que el instructor comparte con los Ztudiantes para que se unan.</p>

            <p className='Help__Subtitle'>Buscar</p>
            <img src='/img/support/help/instructor/groups/2.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Buscar</span>?</p>
            <p>Permite localizar rápidamente un grupo por su nombre. Escribe el nombre completo o parcial en el campo de búsqueda y Ztudia mostrará ese grupo o los grupos relacionados, ocultando los demás para facilitar la gestión.</p>

            <p className='Help__Subtitle'>Listado</p>
            <p>¿Cómo funciona el <span className='Help__Text--Highlight'>Listado</span>?</p>
            <p>Muestra todos los grupos creados por el instructor en forma de tabla con tres columnas:</p>
            <ul className='Help__List'>
                <li className='Help__List__Item'>Nombre: el nombre asignado al grupo.</li>
                <li className='Help__List__Item'>Ztudiantes: cantidad de Ztudiantes registrados.</li>
                <li className='Help__List__Item'>Código: El código único para que los Ztudiantes se unan.</li>
            </ul>

            <p>En cada fila se incluyen botones de acción para gestionar el grupo:</p>
            <img src='/img/support/help/instructor/groups/3.png' className='Help__Image' />
            <p>Ver grupo: consulta los Ztudiantes registrados, acepta o rechaza solicitudes y revisa datos generales.</p>

            <img src='/img/support/help/instructor/groups/4.png' className='Help__Image' />
            <p>Ocultar: archiva el grupo para que no aparezca como activo.</p>

            <img src='/img/support/help/instructor/groups/5.png' className='Help__Image' />
            <p>Eliminar: elimina el grupo de forma permanente.</p>

            <p className='Help__Subtitle'>Ver grupo</p>
            <img src='/img/support/help/instructor/groups/3.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Ver grupo</span>?</p>
            <p>Permite al instructor gestionar los Ztudiantes que se han unido a un grupo. Al acceder, se muestra una tabla la información de los alumnos: nombre, apellidos y usuario.</p>
            <p>Desde esta vista, el instructor puede realizar acciones como:</p>
            <ul className='Help__List'>
                <li className='Help__List__Item'>Aceptar o rechazar solicitudes.</li>
                <li className='Help__List__Item'>Restablecer contraseña.</li>
                <li className='Help__List__Item'>Eliminar Ztudiantes del grupo.</li>
                <li className='Help__List__Item'>Ocultar.</li>
            </ul>
            <p>La información se presenta en formato de tabla con botones de acción visibles para cada Ztudiante, lo que facilita la administración del grupo.</p>

            <p className='Help__Subtitle'>Ocultar</p>
            <img src='/img/support/help/instructor/groups/6.png' className='Help__Image' />
            <p>¿Qué hace la opción <span className='Help__Text--Highlight'>Ocultar</span>?</p>
            <p>Archiva el grupo para que no aparezca como activo en la lista principal. Esta acción no elimina el grupo ni su información, lo mantiene disponible para futuras consultas o reactivación.</p>

            <p className='Help__Subtitle'>Eliminar</p>
            <img src='/img/support/help/instructor/groups/7.png' className='Help__Image' />
            <p>¿Qué hace la opción <span className='Help__Text--Highlight'>Eliminar</span>?</p>
            <p>Elimina el grupo de forma permanente, pero solo si no tiene Ztudiantes asociados. Si el grupo contiene al menos un Ztudiante, no se podrá eliminar. Una vez realizada esta acción, el grupo y su información no podrán recuperarse, por lo que debe usarse con precaución.</p>
        </>
    )
}

export { Groups };